import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconNavigation16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="navigation">
            <path
                d="M0.503431 6.4362L13.97 1.38623C14.372 1.2355 14.7645 1.62802 14.6137 2.02996L9.56377 15.4965C9.39149 15.9559 8.72953 15.9182 8.61053 15.4422L7.07273 9.29104C7.02795 9.1119 6.88807 8.97202 6.70893 8.92724L0.557726 7.38944C0.0817293 7.27044 0.0440249 6.60848 0.503431 6.4362Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
